import React, { ReactNode, useEffect, useRef } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box } from "@mui/material";
import { WithLoadingSpinner } from "@rentablo/components";
import { NoDataStub } from "@rentablo/components";
import { HalfChartDataItem, useChartOptions } from "./useChartOptions";

type Props = {
  width?: number;
  height?: number;
  data: HalfChartDataItem[];
  isFetching?: boolean;
  noDataMessage?: ReactNode;
  activeItem?: string;
  setActiveItem?: (item?: string) => void;
  colors: string[];
};

export const HalfDonutChart = ({
  width,
  height,
  data,
  isFetching,
  noDataMessage,
  activeItem,
  setActiveItem,
  colors,
}: Props) => {
  const chartComponentRef = useRef<HighchartsReact.RefObject>(null);

  const chartOptions = useChartOptions(
    colors,
    data,
    width,
    height,
    activeItem,
    setActiveItem
  );

  useEffect(() => {
    chartComponentRef.current?.chart?.reflow();
  }, [chartOptions]);

  return (
    <Box pb={1}>
      <WithLoadingSpinner isLoading={Boolean(isFetching)} mb={6}>
        {!data.length && !isFetching ? (
          <NoDataStub height="300px" secondLine={noDataMessage} />
        ) : (
          <HighchartsReact
            highcharts={Highcharts}
            options={chartOptions}
            ref={chartComponentRef}
          />
        )}
      </WithLoadingSpinner>
    </Box>
  );
};
